/* eslint-disable @reatom/unit-naming-rule */
import { useAtom } from '@reatom/npm-react'
import React from 'react'
import { styled } from 'styled-components'
import { useMemo } from 'use-memo-one'

import { AsyncStateN } from '@blade/std-lib'
import { reatomImage } from '@root/shared/lib'
import { TooltipCard } from '@root/shared/ui-kit/tooltip-card/tooltip-card'

import { RectangleNetworkBackground } from '../background/rectangle-network'

type Props = {
  children: React.ReactElement
  src: string
  alt?: string
}

export const ImagePopover: React.FC<Props> = React.memo(
  ({ children, src, alt }) => {
    const model = useMemo(() => reatomImage({ src }), [src])
    const [state] = useAtom(model)

    if (!AsyncStateN.isSuccess(state) || !state.value) {
      return children
    }

    return (
      <Root
        closeOnCloseAreaMouseEnter
        side="right"
        closeArea={
          <Content>
            <Preview src={state.value} alt={alt} />
          </Content>
        }
      >
        {children as React.ReactElement<React.RefAttributes<HTMLElement>>}
      </Root>
    )
  },
)

const Preview = styled.img`
  height: 220px;
  width: 220px;
  border-radius: 6px;
  display: block;
  object-fit: cover;
`

const Root = styled(TooltipCard)`
  --tooltip-width: auto;
  --root-padding: 0;
`

const Content = styled.div`
  ${RectangleNetworkBackground}
  margin: 6px;
  border-radius: 6px;
  display: grid;
  gap: 6px;
`
